import React from "react";
import "./textField.css";
import searchIcon from "../../../../assets/images/search-icon.svg";

const TextField = ({ type, className, placeholder, value, onChange, name, disabled = false, showSearchIcon = false, autoComplete = "off" }) => (
  <div className="input-container">
    {showSearchIcon && <img src={searchIcon} alt="search" className="search-icon" />}
    <input
      type={type}
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      name={name}
      disabled={disabled}
      autoComplete={autoComplete}
    />
  </div>
);

export default TextField;
